// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base container styles */
.parent {
  background: white;
  border-radius: 5px;
  height: 100%;
}

/* Main selectable item styling */
.item-selectable-article {
  position: relative;
  margin: 0 auto;
  flex-grow: 1;
  min-height: 100%;
  word-break: break-word;
  background: white;
  border: 2px solid white;
  border-radius: var(--custom-border-radius);
  box-shadow: 0px 2.1px 7.87px 0px rgba(13, 71, 161, 0.1490196078);
  transition: all 200ms linear;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
  cursor: pointer;
  /* Reset button styles */
  font-family: inherit;
  font-size: inherit;
  /* Accessibility focus styles */
  /* Keyboard focus only styles */
  /* Hover state */
  /* Selected state - green background */
  /* Selected state - red background (for removal) */
}
.item-selectable-article:focus {
  outline-offset: 2px;
  box-shadow: 0px 0px 0px 3px rgba(113, 167, 97, 0.25);
}
.item-selectable-article:focus-visible {
  outline-offset: 2px;
  box-shadow: 0px 0px 0px 3px rgba(113, 167, 97, 0.25);
}
.item-selectable-article:hover {
  background-color: #f6faf6;
  transform: translateY(-2px);
}
.item-selectable-article.selected {
  border: 2px solid var(--ion-color-primary);
  background: #f6faf6;
}
.item-selectable-article.selectedRed {
  background: rgba(216, 11, 49, 0.3568627451);
  border: 2px solid #d80b31;
}

/* Item content container */
.item-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
}

/* Selection indicator (checkmark) */
.selection-indicator {
  position: absolute;
  top: 5px;
  left: 5px;
  z-index: 1;
}
.selection-indicator .selected_item_icon {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.selection-indicator .selected_item_icon.active {
  z-index: 99;
  opacity: 1;
}

/* Item details column */
.item-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

/* Image container */
.image-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

/* Food item image */
.item-selectable-article-image {
  margin: 0 auto;
  height: 90px;
  max-width: 90px;
  object-fit: cover;
}

/* Price tag styling */
.option-price {
  font-size: 12px;
  margin: auto;
  font-weight: bold;
  color: black;
}
.option-price.no-price {
  min-height: 12px;
  max-height: 12px;
}

/* Food item name */
.name {
  margin-top: 12px;
  font-size: 14px;
  width: 100%;
  text-align: center;
  font-family: AppFontBold, sans-serif;
  color: black;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Add button styling */
.wrapp {
  padding: 5px;
  width: 100%;
  margin: 0 auto;
}

.add-button {
  width: 100%;
  margin-top: 10px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 8px;
}
.add-button span {
  font-family: AppFontBold;
  color: var(--ion-color-secondary);
  font-size: 14px;
}

/* Quantity selector */
.quantity-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}
.quantity-selector .quantity {
  color: var(--ion-color-secondary);
  font-size: 20px;
  font-family: AppFontBold;
  margin: 0 8px;
}

/* Quantity buttons */
.quantity-btn {
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  /* Focus styles */
  /* Focus-visible styles */
  /* Hover styles */
  /* Visually indicate pressed state */
  /* Icon sizing */
}
.quantity-btn:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.quantity-btn:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.quantity-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.quantity-btn:active {
  transform: scale(0.95);
}
.quantity-btn.add-opacity {
  opacity: 0.5;
}
.quantity-btn ion-icon {
  width: 20px;
  height: 20px;
}

/* VAT information */
.vat {
  color: black;
  font-size: 10px;
}

/* High contrast mode enhancements */
.bsg-high-contrast {
  /* Selection icon in high contrast */
  /* Item text in high contrast */
  /* Add button in high contrast */
  /* Quantity buttons in high contrast */
}
.bsg-high-contrast .item-selectable-article {
  border: 2px solid black;
  /* Selected states in high contrast */
}
.bsg-high-contrast .item-selectable-article:focus {
  outline: 3px solid #0078d7;
  box-shadow: none;
}
.bsg-high-contrast .item-selectable-article.selected {
  border: 3px solid black;
  background: white;
}
.bsg-high-contrast .item-selectable-article.selectedRed {
  border: 3px dashed black;
  background: white;
}
.bsg-high-contrast .selected_item_icon.active {
  border: 1px solid black;
}
.bsg-high-contrast .name,
.bsg-high-contrast .option-price,
.bsg-high-contrast .quantity {
  color: black;
}
.bsg-high-contrast .add-button {
  border: 2px solid black;
}
.bsg-high-contrast .add-button span {
  color: black;
  font-weight: bold;
}
.bsg-high-contrast .quantity-btn:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .quantity-btn ion-icon {
  color: black;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .name {
    font-size: 12px;
  }
  .item-selectable-article-image {
    height: 70px;
    max-width: 70px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-selectable-article-custom/item-selectable-article-custom.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA,0BAAA;AACA;EACC,iBAAA;EACA,kBAAA;EACA,YAAA;AADD;;AAIA,iCAAA;AACA;EACC,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,0CAAA;EACA,gEAAA;EACA,4BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EAEA,wBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,+BAAA;EAMA,+BAAA;EAMA,gBAAA;EAMA,sCAAA;EAMA,kDAAA;AAvBD;AAAC;EACC,mBAAA;EACA,oDAAA;AAEF;AAEC;EACC,mBAAA;EACA,oDAAA;AAAF;AAIC;EACC,yBAAA;EACA,2BAAA;AAFF;AAMC;EACC,0CAAA;EACA,mBAAA;AAJF;AAQC;EACC,2CAAA;EACA,yBAAA;AANF;;AAUA,2BAAA;AACA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAPD;;AAUA,oCAAA;AACA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAPD;AASC;EACC,UAAA;EACA,oCAAA;AAPF;AASE;EACC,WAAA;EACA,UAAA;AAPH;;AAYA,wBAAA;AACA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AATD;;AAYA,oBAAA;AACA;EACC,aAAA;EACA,uBAAA;EACA,WAAA;AATD;;AAYA,oBAAA;AACA;EACC,cAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AATD;;AAYA,sBAAA;AACA;EACC,eAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AATD;AAWC;EACC,gBAAA;EACA,gBAAA;AATF;;AAaA,mBAAA;AACA;EACC,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EAEA,YAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAXD;;AAcA,uBAAA;AACA;EACC,YAAA;EACA,WAAA;EACA,cAAA;AAXD;;AAcA;EACC,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;EACA,kBAAA;AAXD;AAaC;EACC,wBAAA;EACA,iCAAA;EACA,eAAA;AAXF;;AAeA,sBAAA;AACA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAZD;AAcC;EACC,iCAAA;EACA,eAAA;EACA,wBAAA;EACA,aAAA;AAZF;;AAgBA,qBAAA;AACA;EACC,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EAEA,iBAAA;EAMA,yBAAA;EAMA,iBAAA;EAKA,oCAAA;EASA,gBAAA;AApCD;AAWC;EACC,2CAAA;EACA,mBAAA;AATF;AAaC;EACC,2CAAA;EACA,mBAAA;AAXF;AAeC;EACC,qCAAA;AAbF;AAiBC;EACC,sBAAA;AAfF;AAkBC;EACC,YAAA;AAhBF;AAoBC;EACC,WAAA;EACA,YAAA;AAlBF;;AAsBA,oBAAA;AACA;EACC,YAAA;EACA,eAAA;AAnBD;;AAsBA,oCAAA;AACA;EAqBC,oCAAA;EAKA,+BAAA;EAOA,gCAAA;EAUA,sCAAA;AA1DD;AAgBC;EACC,uBAAA;EAOA,qCAAA;AApBF;AAeE;EACC,0BAAA;EACA,gBAAA;AAbH;AAiBE;EACC,uBAAA;EACA,iBAAA;AAfH;AAkBE;EACC,wBAAA;EACA,iBAAA;AAhBH;AAqBC;EACC,uBAAA;AAnBF;AAuBC;;;EAGC,YAAA;AArBF;AAyBC;EACC,uBAAA;AAvBF;AAyBE;EACC,YAAA;EACA,iBAAA;AAvBH;AA6BE;EACC,0BAAA;AA3BH;AA8BE;EACC,YAAA;AA5BH;;AAiCA,2BAAA;AC7RE;ED+RD;IACC,eAAA;EA9BA;EAiCD;IACC,YAAA;IACA,eAAA;EA/BA;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n/* Base container styles */\n.parent {\n\tbackground: white;\n\tborder-radius: 5px;\n\theight: 100%;\n}\n\n/* Main selectable item styling */\n.item-selectable-article {\n\tposition: relative;\n\tmargin: 0 auto;\n\tflex-grow: 1;\n\tmin-height: 100%;\n\tword-break: break-word;\n\tbackground: white;\n\tborder: 2px solid white;\n\tborder-radius: var(--custom-border-radius);\n\tbox-shadow: 0px 2.1px 7.87px 0px #0d47a126;\n\ttransition: all 200ms linear;\n\ttext-align: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\talign-items: center;\n\twidth: 100%;\n\tpadding: 0;\n\tcursor: pointer;\n\n\t/* Reset button styles */\n\tfont-family: inherit;\n\tfont-size: inherit;\n\n\t/* Accessibility focus styles */\n\t&:focus {\n\t\toutline-offset: 2px;\n\t\tbox-shadow: 0px 0px 0px 3px rgba(113, 167, 97, 0.25);\n\t}\n\n\t/* Keyboard focus only styles */\n\t&:focus-visible {\n\t\toutline-offset: 2px;\n\t\tbox-shadow: 0px 0px 0px 3px rgba(113, 167, 97, 0.25);\n\t}\n\n\t/* Hover state */\n\t&:hover {\n\t\tbackground-color: #f6faf6;\n\t\ttransform: translateY(-2px);\n\t}\n\n\t/* Selected state - green background */\n\t&.selected {\n\t\tborder: 2px solid var(--ion-color-primary);\n\t\tbackground: #f6faf6;\n\t}\n\n\t/* Selected state - red background (for removal) */\n\t&.selectedRed {\n\t\tbackground: #d80b315b;\n\t\tborder: 2px solid #d80b31;\n\t}\n}\n\n/* Item content container */\n.item-content {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\twidth: 100%;\n\tposition: relative;\n}\n\n/* Selection indicator (checkmark) */\n.selection-indicator {\n\tposition: absolute;\n\ttop: 5px;\n\tleft: 5px;\n\tz-index: 1;\n\n\t.selected_item_icon {\n\t\topacity: 0;\n\t\ttransition: opacity 0.3s ease-in-out;\n\n\t\t&.active {\n\t\t\tz-index: 99;\n\t\t\topacity: 1;\n\t\t}\n\t}\n}\n\n/* Item details column */\n.item-details {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\twidth: 100%;\n}\n\n/* Image container */\n.image-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 100%;\n}\n\n/* Food item image */\n.item-selectable-article-image {\n\tmargin: 0 auto;\n\theight: 90px;\n\tmax-width: 90px;\n\tobject-fit: cover;\n}\n\n/* Price tag styling */\n.option-price {\n\tfont-size: 12px;\n\tmargin: auto;\n\tfont-weight: bold;\n\tcolor: black;\n\n\t&.no-price {\n\t\tmin-height: 12px;\n\t\tmax-height: 12px;\n\t}\n}\n\n/* Food item name */\n.name {\n\tmargin-top: 12px;\n\tfont-size: 14px;\n\twidth: 100%;\n\ttext-align: center;\n\tfont-family: AppFontBold, sans-serif;\n\n\tcolor: black;\n\tword-break: break-word;\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 4;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n/* Add button styling */\n.wrapp {\n\tpadding: 5px;\n\twidth: 100%;\n\tmargin: 0 auto;\n}\n\n.add-button {\n\twidth: 100%;\n\tmargin-top: 10px;\n\tpadding: 5px 10px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: 1px solid var(--ion-color-secondary);\n\tborder-radius: 8px;\n\n\tspan {\n\t\tfont-family: AppFontBold;\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-size: 14px;\n\t}\n}\n\n/* Quantity selector */\n.quantity-selector {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tz-index: 2;\n\n\t.quantity {\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-size: 20px;\n\t\tfont-family: AppFontBold;\n\t\tmargin: 0 8px;\n\t}\n}\n\n/* Quantity buttons */\n.quantity-btn {\n\twidth: 30px;\n\theight: 30px;\n\tbackground: transparent;\n\tborder: none;\n\tpadding: 5px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcursor: pointer;\n\tborder-radius: 50%;\n\n\t/* Focus styles */\n\t&:focus {\n\t\toutline: 2px solid var(--ion-color-primary);\n\t\toutline-offset: 2px;\n\t}\n\n\t/* Focus-visible styles */\n\t&:focus-visible {\n\t\toutline: 2px solid var(--ion-color-primary);\n\t\toutline-offset: 2px;\n\t}\n\n\t/* Hover styles */\n\t&:hover {\n\t\tbackground-color: rgba(0, 0, 0, 0.05);\n\t}\n\n\t/* Visually indicate pressed state */\n\t&:active {\n\t\ttransform: scale(0.95);\n\t}\n\n\t&.add-opacity {\n\t\topacity: 0.5;\n\t}\n\n\t/* Icon sizing */\n\tion-icon {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n}\n\n/* VAT information */\n.vat {\n\tcolor: black;\n\tfont-size: 10px;\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n\t.item-selectable-article {\n\t\tborder: 2px solid black;\n\n\t\t&:focus {\n\t\t\toutline: 3px solid #0078d7;\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t/* Selected states in high contrast */\n\t\t&.selected {\n\t\t\tborder: 3px solid black;\n\t\t\tbackground: white;\n\t\t}\n\n\t\t&.selectedRed {\n\t\t\tborder: 3px dashed black;\n\t\t\tbackground: white;\n\t\t}\n\t}\n\n\t/* Selection icon in high contrast */\n\t.selected_item_icon.active {\n\t\tborder: 1px solid black;\n\t}\n\n\t/* Item text in high contrast */\n\t.name,\n\t.option-price,\n\t.quantity {\n\t\tcolor: black;\n\t}\n\n\t/* Add button in high contrast */\n\t.add-button {\n\t\tborder: 2px solid black;\n\n\t\tspan {\n\t\t\tcolor: black;\n\t\t\tfont-weight: bold;\n\t\t}\n\t}\n\n\t/* Quantity buttons in high contrast */\n\t.quantity-btn {\n\t\t&:focus {\n\t\t\toutline: 3px solid #0078d7;\n\t\t}\n\n\t\tion-icon {\n\t\t\tcolor: black;\n\t\t}\n\t}\n}\n\n/* Responsive adjustments */\n@include mobile {\n\t.name {\n\t\tfont-size: 12px;\n\t}\n\n\t.item-selectable-article-image {\n\t\theight: 70px;\n\t\tmax-width: 70px;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
